import React, { Component } from 'react';
import { 
    Grid, 
    Box
} from '@material-ui/core';
import { isEmpty } from "lodash";
import InputText, { InputSelect, InputSelectMulti } from '../../../commonModules/interface/form-input-inline';
import DatePickerCustom from '../../../commonModules/interface/DatePickerCustom';

class FilterList extends Component {
    state = { 
        CLIENTS: {},
        METHODPAYMENTS: [],
    }
    componentDidMount = () => {
        if (this.props.PAYMENTS) {
            let CLIENTS = {}
            let METHODPAYMENTS = []
            Object.values(this.props.PAYMENTS).forEach( pay => {
                CLIENTS[pay.boxId] = pay.userName
                if ( !METHODPAYMENTS.find(element => element === pay.methodPayment) ){
                    METHODPAYMENTS.push(pay.methodPayment)
                }
            })
            this.setState({CLIENTS, METHODPAYMENTS})
        }
    }
    render() {
        const { CLIENTS, METHODPAYMENTS } = this.state;
        // console.log('====================================');
        // console.log(this.state, this.props.PAYMENTS);
        // console.log('====================================');
        return (
            <Box >
                <Grid container>
                    <Grid item xs={6}>
                        <InputSelectMulti
                            label="Clients"
                            id="searchClient"
                            options={Object.keys(CLIENTS).map( key => ({
                                label: `${key} - ${CLIENTS[key]}`,
                                value: key,
                                disabled: Array.isArray(this.props.searchClient) && !!this.props.searchClient.find(element => element.value === key)
                            }))}
                            value={this.props.searchClient}
                            onChange={(option) => this.props.handleSelect(option, "searchClient")}
                            isMulti
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <InputSelectMulti
                            label="Type de Paiement"
                            name="searchMethod"
                            onChange={(option) => this.props.handleSelect(option, "searchMethod")}
                            value={this.props.searchMethod}
                            id="searchMethod"
                            options={METHODPAYMENTS.map( method => ({
                                label: method,
                                value: method,
                                disabled: Array.isArray(this.props.searchMethod) && !!this.props.searchMethod.find(element => element.value === method)
                            })) }
                            isMulti
                        />
                    </Grid>                        
                    <Grid item xs={6}>
                        <InputSelect
                            options={[
                                {value: "", label: "Tous"},
                                {value: true, label: "Pointé"},
                                {value: false, label: "Non Pointé"},
                            ]}
                            value={this.props.matched}
                            label="Statut"
                            name="matched"
                            onChange={(option) => this.props.handleSelect(option, "matched")}
                        /> 
                    </Grid>    
                    <Grid item xs={12} md={6}>
                        <InputText
                            label="ID Transaction"
                            value={this.props.searchFacture}
                            name="searchFacture"
                            onChange={this.props.handleChange}
                        /> 
                    </Grid>                    
                    <Grid item xs={12} sm={6} >
                        <DatePickerCustom
                            required
                            label="Du"
                            handleChange={(date) => this.props.handleChangeDate(date, "start_date")}
                            value={this.props.start_date}
                            id="start_date"
                            maxDate={this.props.end_date || new Date()}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} >
                        <DatePickerCustom
                            required
                            label="Au"
                            handleChange={(date) => this.props.handleChangeDate(date, "end_date")}
                            value={this.props.end_date}
                            id="end_date"
                            maxDate={new Date()}
                            minDate={this.props.start_date || new Date()}
                        />
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

export default FilterList;